module.exports = __webpack_public_path__ + "img/noDataOrder.35a18ce5.png";